'use client'; // Needed for hooks and event handlers

import React from 'react';
import NavigationBar from '@/components/layout/NavigationBar';
import Footer from '@/components/layout/Footer';
import LegalViewer from '@/components/common/legalViewer/LegalViewer';
import { termsIt } from './terms-it';
import { useSmoothScroll } from '@/hooks/useSmoothScroll';

export default function TermsPage() {
  useSmoothScroll();

  return (
    <div className="min-h-screen overflow-x-hidden">
      <NavigationBar />
      <main className="flex min-h-screen flex-col pt-16 left-0 right-0">
        <LegalViewer htmlContent={termsIt} />
        <Footer />
      </main>
    </div>
  );
}
